import { isEmptyMarkdownString } from '$/components/ui/EditableInput/utils';
import { urlFields } from '$/utils/isUrl';

const standardizedMentionText = (str) => {
  return str.replace(
    /({\s*)([^\s][a-zA-Z._\s]*[^\s])(\s*})/,
    (_match, _p1, p2) => `{ ${p2.toLowerCase()} }`
  );
};
export const compareMentions = (mention1, mention2) => {
  if (!mention1 || !mention2) return false;
  if (mention1 === mention2) return true;
  if (standardizedMentionText(mention1) === standardizedMentionText(mention2)) return true;
  return false;
};

const defaultSuggestionsFilter = (
  searchValue,
  selectedValue,
  suggestions,
  isUrlInput,
  valueInput,
  maxSizes
) => {
  // Filter default suggestions for UrlInput
  // Just show the Url Mention fields for UrlInput when it's empty or star with `{`
  if (isUrlInput) {
    if (isEmptyMarkdownString(valueInput) || valueInput.startsWith('{')) {
      // Using default link fields instead of link fields from suggestions array.
      // Because some url fields is not suitable for Url Input
      suggestions = urlFields;
    } else {
      suggestions = suggestions.filter((suggestion) => !Boolean(suggestion?.isUrlMention));
    }
  }

  const value = searchValue.toLowerCase();
  const filteredSuggestions = suggestions.filter(
    (suggestion) => !value || suggestion.name.toLowerCase().indexOf(value) > -1
  );
  if (maxSizes) {
    return filteredSuggestions.slice(0, maxSizes);
  }
  if (selectedValue && selectedValue !== '') {
    filteredSuggestions.forEach(function (item, i) {
      if (compareMentions(item.name, selectedValue)) {
        filteredSuggestions.splice(i, 1);
        filteredSuggestions.unshift(item);
      }
    });
  }
  return filteredSuggestions;
};

export default defaultSuggestionsFilter;
